import React from 'react';
import { RadioGroup as HeadlessRadioGroup } from '@headlessui/react';
import { ColocIcon } from '@/components/design-system/atoms/icon';

export interface RadioOption {
  id: string;
  label: string;
}

interface RadioGroupProps {
  options: RadioOption[];
  value: string;
  onChange: (value: string) => void;
  className?: string;
  disabled?: boolean;
}

export const RadioGroup: React.FC<RadioGroupProps> = ({
  options,
  value,
  onChange,
  disabled = false,
  className = '',
}) => {
  return (
    <HeadlessRadioGroup value={value} onChange={onChange}>
      <div className={`flex gap-4 ${className}`}>
        {options.map((option) => (
          <HeadlessRadioGroup.Option
            key={option.id}
            value={option.id}
            disabled={disabled}
            className="disabled:opacity-50"
          >
            {({ checked, disabled: isDisabled }) => (
              <div
                className={`flex items-center ${
                  isDisabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'
                }`}
              >
                {checked ? (
                  <ColocIcon name="radio-checked" size={20} />
                ) : (
                  <ColocIcon name="radio-uncheck" size={20} />
                )}
                <span className="ml-2 text-body font-normal text-text-primaryHeavy">
                  {option.label}
                </span>
              </div>
            )}
          </HeadlessRadioGroup.Option>
        ))}
      </div>
    </HeadlessRadioGroup>
  );
};
